import BaseApi from '../base/apiBase.service'

export default class BusinessService extends BaseApi {
  constructor (args) {
    super(args)

    this.service_uri = {
      get: '/business',
      create: '/business/',
      update: '/business/'
    }
  }

  async getByParameters (data) {
    return super.getByParameters(data);
  }

  async update (data) {
    return super.update(data);
  }

  async create (data) {
    return super.create(data);
  }
}